const FilterComplexCore = require("../core/FilterComplexCore");
module.exports = class FilterComplex extends FilterComplexCore {};
